<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('contacts')">Cliente</inertia-link>
      <span class="text-white font-medium">/       {{ form.nombres}} {{ form.apellidos }}
      </span>
    </h1>
    <trashed-message v-if="contact.deleted_at" class="mb-6" @restore="restore">
     Cliente  Eliminado!
    </trashed-message>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.nombres" :error="form.errors.nombres" class="pr-6 pb-8 w-full lg:w-1/3" label="Nombres" required/>
          <text-input v-model="form.apellidos" :error="form.errors.apellidos" class="pr-6 pb-8 w-full lg:w-1/3" label="Apellidos" required/>
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/3" label="E-mail" required/>
        </div>
        <div class="px-8 py-4 bg-transparent flex justify-between items-center">
          <button v-if="!contact.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Cliente</button>          
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Actualizar Cliente</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.nombres} ${this.form.apellidos}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    contact: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombres: this.contact.nombres,
        apellidos: this.contact.apellidos,
        porcentaje: this.contact.porcentaje,
        organization_id: this.contact.organization_id,
        id_cuenta: this.contact.id_cuenta,
        id_inversion: this.contact.id_inversion,
        email: this.contact.email,
        monto: this.contact.monto,
        user_id: null,
        estado: this.contact.estado,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('contacts.update', this.contact.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('contacts.destroy', this.contact.id))
      }
    },
    insumos() {
        this.$inertia.get(this.route('insumos.create', this.contact.id))
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('contacts.restore', this.contact.id))
      }
    },
  },
}
</script>
